/** Kiosk build flags and role-based webview access (REACT_APP_* at compile time). */

const isTruthyFlag = (value) =>
  value === true || value === 1 || value === 'true' || value === '1';

export function isKioskMode() {
  return process.env.REACT_APP_MODE === 'kiosk';
}

/** Admin without intrusion flag. */
export function isAdminOnlyKioskUser(permissions) {
  return permissions?.user_type === 'admin' && !isTruthyFlag(permissions?.is_intrusion);
}

/** Admin with is_intrusion=true — both webviews. */
export function isAdminWithIntrusionKioskUser(permissions) {
  return permissions?.user_type === 'admin' && isTruthyFlag(permissions?.is_intrusion);
}

/** Non-admin intrusion account. */
export function isIntrusionOnlyKioskUser(permissions) {
  return permissions?.user_type === 'intrusion';
}

export function isKioskSupportedUser(permissions) {
  return (
    isAdminOnlyKioskUser(permissions)
    || isAdminWithIntrusionKioskUser(permissions)
    || isIntrusionOnlyKioskUser(permissions)
  );
}

/** Attendance `/webview` — admin only and admin+intrusion (not pure intrusion). */
export function canAccessKioskWebview(permissions) {
  return permissions?.user_type === 'admin';
}

/** Intrusion `/webview-intrusion` — intrusion-only and admin+intrusion. */
export function canAccessKioskIntrusionWebview(permissions) {
  return isIntrusionOnlyKioskUser(permissions) || isAdminWithIntrusionKioskUser(permissions);
}

/** Default landing after login. */
export function getKioskHomePath(permissions = null) {
  if (isIntrusionOnlyKioskUser(permissions)) {
    return '/webview-intrusion';
  }
  return '/webview';
}
